import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/expediente/getPagosExpediente.php';

export default function getPagosExpediente({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}